import { Component, Input, Output, EventEmitter, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { SlicePipe } from '@angular/common';

import {
  IExtendedLink, ILinkMedia, IPushCardWithLayout,
  PositionEnum, PushSizeEnum, SdListComponent, SdPushCardComponent, SdThemeComponent
} from '@seb/web-design-system/core';

import type { IDevice } from './device/device.interface';
import { SdDeviceComponent } from './device/device.component';

@Component({
  selector: 'sd-devices',
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdListComponent,
    SdDeviceComponent,
    SdPushCardComponent,
    SlicePipe
  ]
})
export class SdDevicesComponent extends SdThemeComponent {
  @Input()
  maxProductDisplayed = 4;

  @Input()
  title: string;

  @Input()
  devices: IDevice[];

  @Input()
  push: IPushCardWithLayout;

  @Input()
  isSmall = false;

  @Input()
  isHovered = true;

  @Output()
  deviceIsClicked = new EventEmitter<IDevice>();

  @Output()
  devicePushIsClicked = new EventEmitter<IExtendedLink | ILinkMedia>();

  positionEnum = PositionEnum;
  pushSizeEnum = PushSizeEnum;

  onDeviceClicked($event: IDevice) {
    this.deviceIsClicked.emit($event);
  }

  onDevicePushClicked($event: IExtendedLink | ILinkMedia) {
    this.devicePushIsClicked.emit($event);
  }
}
